// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__y_hbo8","orDivider":"orDivider__b6dDUc"};